module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAAXNSR0IArs4c6QAAAQBJREFUKFOV0L9KxEAQBvBv1kIIHliIvULActYo1gqCVrb6Hr6Fb+ADWFzvv0qwUQTZnWgaLbzeSis1ZkcGDIQ74eJWszvfbxaGRORIVQ8BfDHzbIzxAsA2AIfOUdUGwJ73/pRCCCdEdGB9ZqYYo3bDY/UVM29Z6BzATk/07ZxbJBG5VdWNnshi+/bTE4D8H+jY0CuAhb6IiB4MvQMYAHhj5vkpi7DZHzS+qRjjHYD19l1VbwAMO7nRBKqqaq6u62sA/jf4wszL3eETyJplWa6klB4BzNhdVZe896MW/omsGUI4I6Jdq5umWSuK4n4qEpHVlNKlc+45y7LNPM8/W/QDZipzzUawGHAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/statics/down.png
// module id = cMg0
// module chunks = 1